import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom, of } from 'rxjs';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  Domande,
  InformativaAziendale,
  InformativaAziendaleService,
} from 'src/app/services/informativa-aziendale/informativa-aziendale.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DialogAnteprimaCompilazioneInfoAzComponent } from './dialog/dialog-anteprima-compilazione-info-az/dialog-anteprima-compilazione-info-az.component';
import { DialogCreaDomandeInformativaComponent } from './dialog/dialog-crea-domande-informativa/dialog-crea-domande-informativa.component';
import { DialogCreaInformativaAziendaleComponent } from './dialog/dialog-crea-informativa-aziendale/dialog-crea-informativa-aziendale.component';

@Component({
  selector: 'app-cfg-informativa-aziendale',
  templateUrl: './cfg-informativa-aziendale.component.html',
  styleUrls: ['./cfg-informativa-aziendale.component.scss'],
  standalone: false,
})
export class CfgInformativaAziendaleComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  @ViewChild('tabella') tabella!: ListaTabellareComponent;
  @ViewChild('tabellaDomande') tabellaDomande!: ListaTabellareComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Titolo',
      forControlName: 'titolo',
      input: 'text',
    },
    {
      titolo: 'Descrizione',
      forControlName: 'descrizione',
      input: 'text',
    },
    {
      titolo: 'Versione',
      forControlName: 'versione',
      input: 'number',
    },
    {
      forControlName: 'stato',
      input: 'multiple-option',
      titolo: 'Stato',
      fnDatiOption: () =>
        of([
          {
            valore: 'ARCHIVIATO',
            desc: 'Archiviato',
          },
          {
            valore: 'PUBBLICATO',
            desc: 'Pubblicato',
          },
          {
            valore: 'BOZZA',
            desc: 'Bozza',
          },
        ]),
      descValueOption: 'desc',
      idValueOption: 'valore',
    },
  ];

  public filtriDomande: Filtri[] = [
    {
      titolo: 'Domanda',
      forControlName: 'domanda',
      input: 'text',
      riempi: true,
    },
    {
      titolo: 'Tipologia',
      forControlName: 'tipo',
      idValueOption: 'id',
      descValueOption: 'descrizione',
      input: 'multiple-option',
      fnDatiOption: () =>
        of(
          this.informativaAziendale.arrayTipologiaRisposta.map((value, index) => ({
            id: value.chiave,
            descrizione: value.valore,
          })),
        ),
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    titolo: {
      title: 'Titolo',
      value: 'titolo',
      sortable: true,
    },
    descrizione: {
      title: 'Descrizione',
      value: 'descrizione',
      sortable: true,
    },
    versione: {
      title: 'Versione',
      value: 'versione',
      sortable: true,
    },
    stdr: {
      title: 'STDR',
      value: (record) => {
        return record?.stdr?.codice ?? '';
      },
      sortable: true,
    },
    stato: {
      title: 'Stato',
      sortable: true,
      campiSort: ['stato'],
      value: (record: any) => {
        if (record?.stato === 'PUBBLICATO') {
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#CCDBCD;width:130px;text-align: center;border-radius: 15px;height:27px"><p style="color:#729373;font-size:13px">Pubblicata</p></div>';
        } else if (record?.stato === 'BOZZA') {
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#FFE199;width:130px;text-align: center;border-radius: 15px;height:27px"><p style="color:#C7A045;font-size:13px">Bozza</p></div>';
        } else if (record?.stato === 'ARCHIVIATO') {
          return '<div style="display: flex;justify-content: center;align-items:center;background-color:#c53032;width:130px;text-align: center;border-radius: 15px;height:27px"><p style="color:#fff;font-size:13px">Archiviato</p></div>';
        } else {
          return '';
        }
      },
    },
    anteprima: {
      type: 'button',
      buttonIcon: 'visibility',
      title: 'Anteprima',
      buttonId: 'anteprima',
      buttonMostraSempre: true,
    },
    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
      nascondiButton: (record) => record?.stato !== 'BOZZA',
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
      buttonMostraSempre: true,
      nascondiButton: (record) => record?.stato !== 'BOZZA',
    },
  };

  public colonneDomande: { [key: string]: Colonna } = {
    domanda: {
      title: 'Domanda',
      value: 'domanda',
      sortable: true,
    },
    tipo: {
      title: 'Tipoplogia',
      value: (record) => {
        return (
          this.informativaAziendale.arrayTipologiaRisposta
            .filter((tipo) => tipo.chiave === record.tipo)
            .map((tipo) => tipo.valore)[0] || ''
        );
      },
      sortable: true,
    },
    modifica: {
      type: 'button',
      buttonIcon: 'edit',
      title: 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
    },
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
      buttonMostraSempre: true,
    },
  };
  constructor(
    public dialog: MatDialog,
    private readonly informativaAziendale: InformativaAziendaleService,
    private readonly utilityService: UtilityService,
  ) {}

  /**
   * Apertura dialog filtri passati da l'esterno
   */
  async creaNuovo(record?: InformativaAziendale) {
    this.spinnerOver.show();

    if (!record) {
      const risp = await firstValueFrom(this.informativaAziendale.getBozza());
      record = risp;
    }
    this.spinnerOver.hide();

    const dialogCreaImpegno = this.dialog.open(DialogCreaInformativaAziendaleComponent, {
      data: {
        informativaAziendale: record,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '99%',
      height: '95%',
      autoFocus: false,
    });

    dialogCreaImpegno.afterClosed().subscribe((result) => {
      this.tabella.caricaDati();
    });
  }

  /**
   * Apertura dialog filtri passati da l'esterno
   */
  async creaNuovaDomanda(record?: Domande) {
    const dialogCreaImpegno = this.dialog.open(DialogCreaDomandeInformativaComponent, {
      data: {
        domanda: record,
        dialogCreaNuovo: true,
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      height: '95%',
      autoFocus: false,
    });

    dialogCreaImpegno.afterClosed().subscribe((result) => {
      this.tabellaDomande.caricaDati();
    });
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    if (!sortBy) {
      sortBy = [
        {
          chiave: 'versione',
          sort: 'desc',
        },
      ];
    }

    return this.informativaAziendale.get(page, pageSize, ricerca, filters, sortBy);
  };

  public fnCaricamentoDatiDomande: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    return this.informativaAziendale.getDomande(page, pageSize, ricerca, filters, sortBy);
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovo(event.data);
        break;
      case 'elimina':
        this._elimina(event.data.idInformativa);
        break;
      case 'anteprima':
        this._anteprima(event.data);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  public bottoniListaClickDomande(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
        this.creaNuovaDomanda(event.data);
        break;
      case 'elimina':
        this._eliminaDomanda(event.data.id);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }

  /**
   * Funzione per eliminare una riga da una lista tabellare
   * @param idRiga id della riga da eliminare
   */
  private _elimina(idRiga: any) {
    this.utilityService.openDialog({
      descrizione: "Confermi di eliminare l'Informativa Aziendale?",
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.informativaAziendale.delete(idRiga).subscribe({
              next: (result: any) => {
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
  private _eliminaDomanda(idRiga: any) {
    this.utilityService.openDialog({
      descrizione: 'Confermi di eliminare la domanda',
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.informativaAziendale.deleteDomanda(idRiga).subscribe({
              next: (result: any) => {
                this.tabellaDomande.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabellaDomande.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
  /**
   * Metodo per la duplicazione di un Impegno
   */
  public _anteprima(infoAz: InformativaAziendale) {
    const dialogCreaTemplateMail = this.dialog.open(DialogAnteprimaCompilazioneInfoAzComponent, {
      data: {
        infoAz,
        inConf: true,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      height: '95%',
      autoFocus: false,
    });

    dialogCreaTemplateMail.afterClosed().subscribe((statoCompilatoInChiusura) => {});
  }
}
